import { render } from "./user-reports.vue?vue&type=template&id=d7c9e90c"
import script from "./user-reports.vue?vue&type=script&lang=js"
export * from "./user-reports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__